module.exports = __webpack_public_path__ + "img/but_table_confirmbet.e246d96d.png";